import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {FormbirdInjectorService} from 'formbird-services';
import {ChangedDocumentService} from 'formbird-services';
import {GanttChartDhtmlComponentDefinition} from './gantt-chart-dhtml.component.definition';
import * as moment from 'moment';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { SearchService } from '@services/search/search.service';

declare global {
  interface Window {
    dhtmlxgantt: any;
  }
}

@Component({
  templateUrl: './gantt-chart-dhtml.component.html',
  styleUrls: ['./gantt-chart-dhtml.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GanttChartDhtmlComponent extends AbstractComponent<GanttChartDhtmlComponentDefinition> implements OnInit, AfterViewInit {

  @Input() docs: object = {};

  @ViewChild('elemWrp', {static: false}) elemWrp: ElementRef;
  @ViewChild('elemGanttChart', {static: false}) elemGanttChart: ElementRef;

  // service
  dataService: any;
  notificationService: any;

  //
  hideRequired: boolean;
  isRequired: boolean;

  //
  test;
  filter;
  statusField;
  taskDateField;
  taskDurationField;
  parentField;
  progressField;
  taskStartDate;
  taskEndDate;
  taskDurationTimeUnit;
  taskDurationStep;
  taskUnit;
  taskUnitFormat;
  taskUnitStep;
  subscales;
  minColumnWidth;

  ganttChart;
  ganttx;
  ganttInitLoad = false;
  options;
  filterObj;
  zoomFix = false;
  cachedSettings: any = {};
  scaleConfigs; // Setting available scales

  constructor(
    protected cd: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    private searchService: SearchService,
    protected formbirdInjectorService: FormbirdInjectorService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cd);
    this.dataService = this.formbirdInjectorService.get('DataService');
    this.notificationService = this.formbirdInjectorService.get('NotificationService');
  }

  ngOnInit() {
    this.componentSetupService.setupStandardProperties(this);

    this.initializeFieldValue();

    if (!(typeof this.componentDefinition.mandatory === 'undefined' || this.componentDefinition.mandatory === null)) {
      this.isRequired = this.componentDefinition.mandatory;
    } else {
      this.isRequired = false;
    }
    this.hideRequired = !this.isRequired;
    this.componentDefinition = this.template.components[this.key];

    if (!(typeof this.componentDefinition.test === 'undefined' || this.componentDefinition.test === null)) {
      this.test = this.componentDefinition.test;
    }
    this.filter = {};
    if (!(typeof this.componentDefinition.filter === 'undefined' || this.componentDefinition.filter === null)) {
      this.filter = this.componentDefinition.filter;
    }

    // Response fields data map
    if (!(typeof this.componentDefinition.statusField === 'undefined' || this.componentDefinition.statusField === null)) {
      this.statusField = this.componentDefinition.statusField;
    }
    if (!(typeof this.componentDefinition.taskDateField === 'undefined' || this.componentDefinition.taskDateField === null)) {
      this.taskDateField = this.componentDefinition.taskDateField;
    }
    if (!(typeof this.componentDefinition.taskDurationField === 'undefined' || this.componentDefinition.taskDurationField === null)) {
      this.taskDurationField = this.componentDefinition.taskDurationField;
    }
    if (!(typeof this.componentDefinition.parentField === 'undefined' || this.componentDefinition.parentField === null)) {
      this.parentField = this.componentDefinition.parentField;
    }
    if (!(typeof this.componentDefinition.progressField === 'undefined' || this.componentDefinition.progressField === null)) {
      this.progressField = this.componentDefinition.progressField;
    }
    if (!(typeof this.componentDefinition.taskStartDate === 'undefined' || this.componentDefinition.taskStartDate === null)) {
      this.taskStartDate = this.componentDefinition.taskStartDate;
    }
    if (!(typeof this.componentDefinition.taskEndDate === 'undefined' || this.componentDefinition.taskEndDate === null)) {
      this.taskEndDate = this.componentDefinition.taskEndDate;
    }
    if (!(typeof this.componentDefinition.taskDurationTimeUnit === 'undefined' || this.componentDefinition.taskDurationTimeUnit === null)) {
      this.taskDurationTimeUnit = this.componentDefinition.taskDurationTimeUnit;
    }
    if (!(typeof this.componentDefinition.taskDurationStep === 'undefined' || this.componentDefinition.taskDurationStep === null)) {
      this.taskDurationStep = this.componentDefinition.taskDurationStep;
    }
    if (!(typeof this.componentDefinition.taskUnit === 'undefined' || this.componentDefinition.taskUnit === null)) {
      this.taskUnit = this.componentDefinition.taskUnit;
    }
    if (!(typeof this.componentDefinition.taskUnitFormat === 'undefined' || this.componentDefinition.taskUnitFormat === null)) {
      this.taskUnitFormat = this.componentDefinition.taskUnitFormat;
    }
    if (!(typeof this.componentDefinition.taskUnitStep === 'undefined' || this.componentDefinition.taskUnitStep === null)) {
      this.taskUnitStep = this.componentDefinition.taskUnitStep;
    }
    if (!(typeof this.componentDefinition.subscales === 'undefined' || this.componentDefinition.subscales === null)) {
      this.subscales = this.componentDefinition.subscales;
    }
    if (!(typeof this.componentDefinition.minColumnWidth === 'undefined' || this.componentDefinition.minColumnWidth === null)) {
      this.minColumnWidth = this.componentDefinition.minColumnWidth;
    }

    this.ganttChart = this.fieldName + 'ganttchartdhtmlx' + this.key;
    this.ganttInitLoad = false;

    this.options = {
      document: this.document,
      filter: {},
      includeDeleted: false,
      searchOfflineOnly: false
    };
    this.filterObj = JSON.parse(this.filter.replace(/'/g, '"'));

    // Secure the sort object to be empty, avoid adding duplicate sort fields
    if (typeof this.filterObj.sort === 'undefined' || this.filterObj.sort.length > 0) {
      this.filterObj.sort = [];
    }
    if (this.filterObj.query.bool.should === undefined) {
      this.filterObj.query.bool.should = [];
    }
    if (this.filterObj.query.bool.must === undefined) {
      this.filterObj.query.bool.must = [];
    }

    if (this.statusField !== '') {
      const sortObj = {};
      sortObj[this.statusField] = 'asc';
      this.filterObj.sort.push(sortObj);
    }

    const rangeQry = '{"range": {"' + this.taskDateField + '": {"gte": "'
     + moment(this.taskStartDate).format('YYYY-MM-DD') + '","lte": "'
     + moment(this.taskEndDate).format('YYYY-MM-DD') + '"}}}';

    this.filterObj.query.range = JSON.parse(rangeQry);
    this.filterObj.query.bool.must.push(JSON.parse(rangeQry));

    this.options.filter = this.filterObj;

  }

  initializeFieldValue() {
    if ((this.document && this.document[this.componentDefinition.name])) {
      this.docs[this.fieldName] = this.document[this.componentDefinition.name];
      this.fieldValue = this.document[this.componentDefinition.name];

    }
  }

  ngAfterViewInit() {
    this.loadChartScript().then((gantt: any) => {
      this.ganttx = gantt;
      const id = this.fieldName + 'ganttchartdhtmlx' + this.key;
      gantt.init(id); // Gantt.getGanttInstance();
      this.loadChartData();
    });
  }


  loadChartScript() {
    return new Promise((resolve) => {
      const dynamicScriptUrl = 'https://cdn.dhtmlx.com/gantt/edge/dhtmlxgantt.js';

      const node = document.createElement('script');
      node.src = dynamicScriptUrl;
      node.type = 'text/javascript';
      node.async = false;
      node.onload = () => {
        console.log('******* load chart script done *******************');
        resolve(window.dhtmlxgantt.gantt);
      };
      document.getElementsByTagName('head')[0].appendChild(node);
    });
  }

  loadChartData() {
    this.scaleConfigs = [
      // minutes
      {
        unit: 'minute', step: 1, scale_unit: 'hour', date_scale: '%H', subscales: [
          {unit: 'minute', step: 1, date: '%H:%i'}
        ]
      },
      // hours
      {
        unit: 'hour', step: 1, scale_unit: 'day', date_scale: '%j %M',
        subscales: [
          {unit: 'hour', step: 1, date: '%H:%i'}
        ]
      },
      // days
      {
        unit: 'day', step: 1, scale_unit: 'month', date_scale: '%F',
        subscales: [
          {unit: 'day', step: 1, date: '%j'}
        ]
      },
      // weeks
      {
        unit: 'week', step: 1, scale_unit: 'month', date_scale: '%F',
        subscales: [
          {
            unit: 'week', step: 1, template: (date) => {
              const dateToStr = this.ganttx.date.date_to_str('%d %M');
              const endDate = this.ganttx.date.add(this.ganttx.date.add(date, 1, 'week'), -1, 'day');
              return dateToStr(date) + ' - ' + dateToStr(endDate);
            }
          }
        ]
      },
      // months
      {
        unit: 'month', step: 1, scale_unit: 'year', date_scale: '%Y',
        subscales: [
          {unit: 'month', step: 1, date: '%M'}
        ]
      },
      // quarters
      {
        unit: 'month', step: 3, scale_unit: 'year', date_scale: '%Y',
        subscales: [
          {
            unit: 'month', step: 3, template:  (date) => {
              const dateToStr = this.ganttx.date.date_to_str('%M');
              const endDate = this.ganttx.date.add(this.ganttx.date.add(date, 3, 'month'), -1, 'day');
              return dateToStr(date) + ' - ' + dateToStr(endDate);
            }
          }
        ]
      },
      // years
      {
        unit: 'year', step: 1, scale_unit: 'year', date_scale: '%Y',
        subscales: [
          {
            unit: 'year', step: 5, template: (date) => {
              const dateToStr = this.ganttx.date.date_to_str('%Y');
              const endDate = this.ganttx.date.add(this.ganttx.date.add(date, 5, 'year'), -1, 'day');
              return dateToStr(date) + ' - ' + dateToStr(endDate);
            }
          }
        ]
      },
      // decades
      {
        unit: 'year', step: 10, scale_unit: 'year', template: (date) => {
          const dateToStr = this.ganttx.date.date_to_str('%Y');
          const endDate = this.ganttx.date.add(this.ganttx.date.add(date, 10, 'year'), -1, 'day');
          return dateToStr(date) + ' - ' + dateToStr(endDate);
        },
        subscales: [
          {
            unit: 'year', step: 100, template: (date) => {
              const dateToStr = this.ganttx.date.date_to_str('%Y');
              const endDate = this.ganttx.date.add(this.ganttx.date.add(date, 100, 'year'), -1, 'day');
              return dateToStr(date) + ' - ' + dateToStr(endDate);
            }
          }
        ]
      }
    ];

    this.searchService.search(this.options).then( (response) => {
      const dataSet = {data: []};
      const d =  Math.floor(Math.random() * (24 - 15 + 1)) + 15;
      response.data.hits.hits.forEach((hit: any) => {
        const line = hit._source;
        let duration = d;
        if (this.taskDurationField) {
          const taskDurationFieldResponse = line[this.taskDurationField];
          if (taskDurationFieldResponse) {
            duration = taskDurationFieldResponse;
          }
        }
        let parentField = '';
        if (this.parentField) {
          const taskParentField = line[this.parentField];
          if (taskParentField) {
            parentField = taskParentField;
          }
        }
        let progressField = '';
        if (this.progressField) {
          const taskProgressField = line[this.progressField];
          if (taskProgressField) {
            progressField = taskProgressField;
          }
        }
        let statusField = '';
        if (this.statusField) {
          const taskStatusField = line[this.statusField];
          if (taskStatusField) {
            statusField = taskStatusField;
          }
        }
        const dataLine = {
          id: line.documentId,
          text: line.systemHeader.summaryName,
          start_date: moment(line.actionDate).format('DD-MM-YYYY'),
          duration: duration,
          parent: parentField,
          progress: progressField,
          open: statusField
        };
        // console.log('dataLine = ', dataLine);
        dataSet.data.push(dataLine);
      });
      // if (this.test) {
      //     if (this.taskDurationTimeUnit === 'minute') {
      //       dataSet = this.hourlyData; // can't find declaration/assign of hourly_data & demo_tasks in angularJS version
      //     } else {
      //       dataSet = this.demoTasks;
      //     }
      // }


      this.ganttx.attachEvent('onDataRender', () => {
        if (this.ganttInitLoad) {
          console.log('On Data Render..');
        }
      });
      this.ganttx.attachEvent('onBeforeDataRender', () => {
        this.ganttInitLoad = true;
        console.log('Before Data Render');
      });


      this.ganttx.attachEvent('onParse', () => {
        this.ganttInitLoad = true;
        console.log('Gantt Chart Inizialized');
      });

      this.ganttx.attachEvent('onAfterTaskUpdate', (docId, item) => {
        this.ganttInitLoad = true;
        console.log(docId, item);
        // scope.unsavedDocumentListId = docId;

        // ModifiedFieldService.addModifiedField(docId, scope.fieldName, scope.formParameters.unsavedDocumentListId);
        this.dataService.getDocument(docId).then(
          (data) => {
            if (data) {
              const jsonData = JSON.stringify(data);
              const modifiedData: any = JSON.parse(jsonData);

              // Date Field
              if (modifiedData[this.taskDateField]) {
                  modifiedData[this.taskDateField] = item.start_date.toISOString();
              }

              // Duration Field
              if (modifiedData[this.taskDurationField]) {
                modifiedData[this.taskDurationField] = item.duration;
              }

              // Progess Field
              if (modifiedData[this.progressField]) {
                modifiedData[this.progressField] = item.progress;
              }


              modifiedData.systemHeader.summaryName = item.text;

              this.dataService.deepDiffUpdate(data, modifiedData).then(
                  (result) => {
                    this.notificationService.success('Save successfully.');
                  },
                  (err) => {
                    this.notificationService.error('Saved error');
                  }
              );
            }
          },
          (err: any) => {
              if (err.name === 'ForbiddenError') {
                this.notificationService.error('Access Restricted');
              } else {
                this.notificationService.error('Save error');
              }
          });
      });

      // date format: https://docs.dhtmlx.com/gantt/desktop__date_format.html
      // scale units: https://docs.dhtmlx.com/gantt/api__gantt_scale_unit_config.html
      this.ganttx.config.scale_unit = this.taskUnit;
      this.ganttx.config.step = this.taskUnitStep;
      this.ganttx.config.date_scale = this.taskUnitFormat;
      this.ganttx.config.duration_unit = this.taskDurationTimeUnit;
      this.ganttx.config.duration_step = this.taskDurationStep;
      this.ganttx.config.scale_height = 75;
      if (this.componentDefinition.fullWidth) {
        this.ganttx.config.min_column_width = this.minColumnWidth;
      }
      else {
        this.configLayout();
      }


      this.ganttx.config.subscales = this.subscales;

      if (this.taskStartDate) {
        // ganttx.config.start_date = taskStartDate;
      }

      if (this.taskEndDate) {
        // ganttx.config.end_date = taskEndDate;
      }

      // ganttx.config.start_date = new Date("2018-03-31");
      // ganttx.config.end_date = new Date("2018-04-30");
      this.ganttx.init(this.ganttChart);
      this.ganttx.parse(dataSet);
    });
  }

  toggleMode(toggle) {
    this.elemWrp.nativeElement.classList.add('gantt-load');
    // this.zoomFix = !this.zoomFix;
    this.zoomFix = false;
    if (this.zoomFix) {
      toggle.target.innerHTML = 'Set default Scale';
      // Saving previous scale state for future restore
      this.saveConfig();
      this.zoomToFit();

    } else {
      toggle.target.innerHTML = 'Reload';
      // Restore previous scale state
      // 			restoreConfig();
      this.ganttx.render();
    }
    this.elemWrp.nativeElement.classList.remove('gantt-load');
  }
  saveConfig() {
    const config = this.ganttx.config;
    this.cachedSettings = {};
    this.cachedSettings.scale_unit = config.scale_unit;
    this.cachedSettings.date_scale = config.date_scale;
    this.cachedSettings.step = config.step;
    this.cachedSettings.subscales = config.subscales;
    this.cachedSettings.template = this.ganttx.templates.date_scale;
    this.cachedSettings.start_date = config.start_date;
    this.cachedSettings.end_date = config.end_date;
  }
  restoreConfig() {
    this.applyConfig(this.cachedSettings, null);
  }
  applyConfig(config, dates) {
    this.ganttx.config.scale_unit = config.scale_unit;
    if (config.date_scale) {
      this.ganttx.config.date_scale = config.date_scale;
      this.ganttx.templates.date_scale = null;
    } else {
      this.ganttx.templates.date_scale = config.template;
    }

    this.ganttx.config.step = config.step;
    this.ganttx.config.subscales = config.subscales;

    if (dates && dates.start_date && dates.start_date) {
      this.ganttx.config.start_date = this.ganttx.date.add(dates.start_date, -1, config.unit);
      this.ganttx.config.end_date = this.ganttx.date.add(this.ganttx.date[config.unit + '_start'](dates.end_date), 2, config.unit);
    } else {
      this.ganttx.config.start_date = this.ganttx.config.end_date = null;
    }
  }
  zoomToFit() {
    const project = this.ganttx.getSubtaskDates();
    const areaWidth = this.ganttx.$task.offsetWidth;
    let i = 0;
    for (i = 0; i < this.scaleConfigs.length; i++) {
      const columnCount = this.getUnitsBetween(project.start_date, project.end_date
        , this.scaleConfigs[i].unit, this.scaleConfigs[i].step);
      if ((columnCount + 2) * this.ganttx.config.min_column_width <= areaWidth) {
        break;
      }
    }

    if (i === this.scaleConfigs.length) {
      i--;
    }

    this.applyConfig(this.scaleConfigs[i], project);
    this.ganttx.render();
  }
  // get number of columns in timeline
  getUnitsBetween(from, to, unit, step) {
    let start = new Date(from);
    const end = new Date(to);
    let units = 0;
    while (start.valueOf() < end.valueOf()) {
      units++;
      start = this.ganttx.date.add(start, step, unit);
    }
    return units;
  }

  configLayout() {
      this.ganttx.config.layout = {
        css: "gantt_container",
        cols:[
          {
            rows:[
              {
                view: "grid",
                scrollable:true,
                scrollX:"scrollHor1",
                scrollY:"scrollVer"
              },
              {
                view: "scrollbar",
                id:"scrollHor1",
                scroll:'x',
                group:'hor'
              },
            ]
          },
          {resizer: true, width: 1},
          {
            rows:[
              {
              view: "timeline",
              scrollX:"scrollHor",
              scrollY:"scrollVer"
            },
            {
              view: "scrollbar",
              id:"scrollHor",
              scroll:'x',
              group:'hor'
            },
            ]
        },
          {
            view: "scrollbar",
            id:"scrollVer"
        }
        ]
      }
  }
}
